import React, {useEffect, useState} from 'react';
import './SysadminUsers.css';
import {useRegisterUser} from "../../../hooks/Sysadmin/useRegisterUser";
import {Bounce, toast} from "react-toastify";

const roleOptions = [
    {value: '', label: 'Seleccione un rol'},
    {value: 'TECHNICIAN', label: 'Técnico'},
    {value: 'ADMINISTRATIVE', label: 'Administrativo'},
    {value: 'SUPERVISOR', label: 'Supervisor'},
    {value: 'SALES_REP', label: 'Atención a clientes'},
    {value: 'SYSADMIN', label: 'Administrador del sistema'}
];

const SysadminUsers = () => {
    const [fullName, setFullName] = useState('');
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [mainPhone, setMainPhone] = useState('');
    const [secondaryPhone, setSecondaryPhone] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [role, setRole] = useState('');
    const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);

    const {registerUser, loading} = useRegisterUser();

    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    const validateFullName = (fullName: string) => {
        const fullNameRegex = /^.{1,50}$/; // Allows any character but limits length
        return fullNameRegex.test(fullName);
    };

    const validateEmail = (email: string) => {
        const emailRegex = /^[^\s@]{1,64}@[^\s@]{1,186}\.[^\s@]+$/;
        return email.length <= 250 && emailRegex.test(email);
    };

    const validatePhone = (phone: any) => {
        const phoneRegex = /^[+]?[0-9]{10,15}$/;
        return phoneRegex.test(phone);
    };

    const validatePassword = (password: string) => {
        const allowedSymbols = "!#$%&*?.";
        const passwordRegex = new RegExp(
            `^(?=.*[A-Z])(?=.*[${allowedSymbols.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}])(?=.*[a-z])(?=.*[0-9])[A-Za-z0-9${allowedSymbols}]{8,20}$`
        );

        return passwordRegex.test(password);
    };

    const validateUsername = (username: string) => {
        const usernameRegex = /^[a-z0-9]{5,15}$/;
        return usernameRegex.test(username);
    };

    const handleAddUserSubmit = async (e: any) => {
        e.preventDefault();

        if (!validateFullName(fullName)) {
            toast.error("El nombre completo no puede exceder los 80 caracteres.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        if (!validateEmail(email)) {
            toast.error("El formato del correo electrónico no es válido.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        if (!validatePhone(mainPhone)) {
            toast.error("El teléfono principal no es válido. Por favor, ingrese un número válido.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        if (secondaryPhone && !validatePhone(secondaryPhone)) {
            toast.error("El teléfono secundario no es válido. Por favor, ingrese un número válido.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        if (!validatePassword(password)) {
            toast.error("La contraseña debe tener entre 8 y 20 caracteres, incluir una letra mayúscula, un número y un símbolo permitido.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        if (!validateUsername(username)) {
            toast.error("El nombre de usuario solo debe contener letras minúsculas y números, y tener entre 5 y 15 caracteres.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        const newUserDTO = {
            username,
            fullName,
            email,
            password,
            mainPhone,
            secondaryPhone,
            role,
        };

        try {
            await registerUser(newUserDTO);
            toast.success('¡Usuario creado correctamente!', {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            resetForm();
        } catch (err:any) {
            toast.error(err.message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        }
    };

    const resetForm = () => {
        setUsername('');
        setFullName('');
        setEmail('');
        setMainPhone('');
        setSecondaryPhone('');
        setPassword('');
        setRole('');
    };

    useEffect(() => {
        const isDisabled = !fullName || !username || !email || !mainPhone || !password || !role;
        setIsConfirmDisabled(isDisabled);
    }, [fullName, username, email, mainPhone, password, role]);

    return (
        <div>
            {loading ? (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                    <div className="loading-message">
                        {loading ? 'Guardando...' : 'Obteniendo clientes...'}
                    </div>
                </div>
            ) : (
                <div>
                    <div className="add-user-header">
                        <span className="material-icons user" aria-label="edit ticket">
                            border_color
                        </span>
                        <p className="header-title">AÑADIR USUARIO</p>
                    </div>
                    <form onSubmit={handleAddUserSubmit} className="form-group-add-user">
                        <div className="form-item-add-user">
                            <label htmlFor="fullname">NOMBRE COMPLETO *</label>
                            <input
                                id="fullname"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                            />
                        </div>
                        <div className="form-item-add-user">
                            <label htmlFor="email">EMAIL *</label>
                            <input
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="form-item-add-user">
                            <label htmlFor="mainPhone">TELÉFONO PRINCIPAL *</label>
                            <input
                                id="mainPhone"
                                value={mainPhone}
                                onChange={(e) => setMainPhone(e.target.value)}
                            />
                        </div>
                        <div className="form-item-add-user">
                            <label htmlFor="secondaryPhone">TELÉFONO SECUNDARIO</label>
                            <input
                                id="secondaryPhone"
                                value={secondaryPhone}
                                onChange={(e) => setSecondaryPhone(e.target.value)}
                            />
                        </div>
                        <div className="form-item-add-user">
                            <label htmlFor="fullname">NOMBRE DE USUARIO *</label>
                            <input
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                        <div className="form-item-add-user">
                            <label htmlFor="password">CONTRASEÑA *</label>
                            <div className="password-container">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Ingresa tu contraseña"
                                />
                                <button
                                    type="button"
                                    className="password-toggle-button"
                                    onClick={togglePasswordVisibility}
                                >
                                <span className="material-icons">
                                    {showPassword ? 'visibility_off' : 'visibility'}
                                </span>
                                </button>
                            </div>
                            <p className="password-requirements">
                                La contraseña debe tener entre 8 y 20 caracteres,sin espacios, incluir al menos una letra mayúscula, un
                                número y uno de los siguientes símbolos permitidos: ! # $ % . & * ?
                            </p>
                        </div>
                        <div className="form-item-add-user">
                            <label htmlFor="role">ROL *</label>
                            <select
                                id="role"
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                            >
                                {roleOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="bottom">
                            <p>* Campos obligatorios</p>
                            <div className="buttons">
                                <button type="button" className="cancel" onClick={resetForm}>
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className={`confirm ${isConfirmDisabled || loading ? 'disabled' : ''}`}
                                    disabled={isConfirmDisabled || loading}
                                >
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default SysadminUsers;
